import React from 'react';
import { Pagination as AntPagination } from 'antd';
import styles from './Pagination.module.css';

export interface PaginationComponentProps {
  current?: number;
  total: number;
  pageSize?: number;
  onPageChange?: (page: number, pageSize?: number) => void;
  onPageSizeChange?: (current: number, size: number) => void;
  showSizeChanger?: boolean;
  showTotal?: boolean | ((total: number) => string);
  itemName?: string;
  pageSizeOptions?: string[];
}

export const Pagination: React.FC<PaginationComponentProps> = ({
  current = 1,
  total,
  pageSize = 10,
  onPageChange,
  onPageSizeChange,
  showSizeChanger = true,
  showTotal = true,
  itemName = 'nhân viên',
  pageSizeOptions = ['10', '20', '50', '100'],
}) => {
  const getTotalText = (total: number) => {
    if (typeof showTotal === 'function') {
      return showTotal(total);
    }
    return `Tổng ${total} ${itemName}`;
  };

  return (
    <div className={styles.paginationContainer}>
      {showTotal && (
        <div className={styles.totalText}>{getTotalText(total)}</div>
      )}
      <AntPagination
        current={current}
        total={total}
        pageSize={pageSize}
        onChange={onPageChange}
        onShowSizeChange={onPageSizeChange}
        showSizeChanger={showSizeChanger}
        showQuickJumper={false}
        pageSizeOptions={pageSizeOptions}
        className={styles.pagination}
      />
    </div>
  );
};

